
var table = require('../js/modules/table/table.js');
var odds = require('../js/modules/odds/odds.js');
var ticket = require('../js/modules/ticket/ticket.js');
var slip = require('../js/modules/ticket/slip.js');
var results = require('../js/modules/results/results.js');
var video = require('../js/modules/video/video.js');

// 0 - Open bets | 1 - Gamesin progress | 2 - games finished
var gameState = 0;
var waitTimer = 0;
var betOpen = false;

var latestResultsBackup = localStorage.getItem('last_result');
if (latestResultsBackup !== null) {
    window.latestResults = JSON.parse(latestResultsBackup);
    console.log('COLLECTED latestResults : ', latestResults);
} else {
    window.latestResults = {};
}

window.currenPopularOdds = {};
window.underdogs = {};

var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us'];

if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
  window['API_URL'] = SPECIAL_API_URL;
  console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
} else {
  window['API_URL'] = API_URL;
}

import Api from './api/api';
import Auth from './auth/auth';
import User from './user/user';
import LoginModalHelper from './helpers/login-modal-helper';
import Credit from './credit/credit';
import CookieHelper from './helpers/cookie-helper';
import NavbarDisplay from './navbar/navbar-display';
import {chat} from '../../lucky-balls/js/chat';

let api = new Api(window['API_URL'] + '/vfootball-league');
let user = new User();
let auth = new Auth(api);
let credit = new Credit(api);
let navbar = new NavbarDisplay(); 

window.addEventListener('get_tickets_no_stats', function () {
    ticket.getTickets();
});

// register login event listener
window.addEventListener('logout', function () {
    auth.logout();
});

window.addEventListener('get_credit', function () {
    credit.getCredit(user);
});

window.addEventListener('payout', function () {
    credit.requestPayout(user);
});

function showNavbar(){
    // checks if showLogin response is set to 1
    if (window['showLogin'] == 1) {
        $('.game-nav-bar').css('display', 'flex');
    } else {
        $('.game-nav-bar').css('display', 'none');
    }
}

function loginManagement(auth, user, navbar, credit)  {

    if (user.isLogggedIn()) {
        window['token'] = CookieHelper.get('token');
        // make fake response object
        let response = {
            Data: {
                AuthUserResponse: [
                    {
                        Credit: credit.getCredit(user),
                        Currency: CookieHelper.get('currency')
                    }
                ]
            }
        };

        navbar.showLogedIn(user, response);

    } else {
        navbar.showLogedOut();
    }

    $('.logout-button').click(() => {
        var logoutEvent = new CustomEvent("logout");
        window.dispatchEvent(logoutEvent);
    });

    $('.login-button').click(() => {
        $('.login-modal').modal('show');
    });

    $('.login-user-button').click(() => {
        auth.login(LoginModalHelper.bind(user));
    });

    $('.user-username').on('keydown', function(e) {
        if (e.which == 13) {
            auth.login(LoginModalHelper.bind(user));
        }
    });

    $('.user-password').on('keydown', function(e) {
        if (e.which == 13) {
            auth.login(LoginModalHelper.bind(user));
        }
    });

    $('.login-modal').on('hidden.bs.modal', function () {
        LoginModalHelper.clearloginInputs();
    });

    $('.payout-pin-button').click(() => {
        var payoutEvent = new CustomEvent("payout");
        window.dispatchEvent(payoutEvent);
    });
}


$(document).ready(function(){
    init();

    $('#bet-offer').on('click', '.bet-choose', function() {
        if($(this).hasClass('gt-odds-disabled')){
            return false;
        }

        if($(this).hasClass('gt-odds-active')){
             slip.removeFromSlip($(this).parent().parent().parent().attr('data-id'), $(this).attr('data-betCode'));
             return false;
        }
        var playId = $(this).parent().parent().parent().parent().attr('data-id');
        var homeTeam = $(this).parent().parent().parent().parent().attr('data-homeTeam');
        var awayTeam = $(this).parent().parent().parent().parent().attr('data-awayTeam');
        var betType = $(this).attr('data-betType');
        var betCode = $(this).attr('data-betCode');
        var odd = $(this).attr('data-odd');
        slip.addToSlip(playId, homeTeam, awayTeam, odd, betType, betCode, $(this), language);
    });

    $('#slip-matches').on('click', '.slip-x', function() {
        slip.removeFromSlip($(this).attr('data-matchid').slice(0, ($(this).attr('data-matchid').length - $(this).attr('data-betCode').length)-1), $(this).attr('data-betCode'));
    });

    $('body').on('click','.styled-checkbox', function() {
        slip.selectSystem($(this))
    });

    $('body').on('click', '#min-bet', function () {
        slip.setBetValue($(this).data('value'));
    });

    $('body').on('click', '#max-bet', function () {
        slip.setBetValue($(this).data('value'));
    });

    $('body').on('click', '#bet-100', function () {
        slip.setBetValue($(this).data('value'));
    });

    $('body').on('click', '#bet-200', function () {
       slip.setBetValue($(this).data('value'));
    });

    $('body').on('click', '#bet-400', function () {
        slip.setBetValue($(this).data('value'));
    });

    $('#slip-btn').on('input', function(){
        slip.setBetValue($(this).val());
    });

    $('body').on('click', '#slip-amount-up', function () {
        slip.slipValueUp();
    });

    $('body').on('click', '#slip-amount-down', function () {
       slip.slipValueDown();
    });

    $('body').on('click', '#buy-ticket-btn', function () {
        ticket.buyTicket(credit,user);
    });

    $('body').on('click', '#clearAllBets', function () {
        slip.emptySlip();
    });

    $('body').on('click', '#favoritesButton', function () {
       slip.emptySlip();
       $.each(window.currenPopularOdds, function( key, value ) {
           var parentPopular = $("[data-popular='" + value.playId +"']");
           var gameDiv = $("[data-betCode='" + value.betCode +"']", parentPopular );
           slip.addToSlip(value.playId, value.homeTeam, value.awayTeam, value.odd, value.betType, value.betCode, gameDiv, language);
       });
    });

    $('body').on('click', '#underdogsButton', function () {
        slip.emptySlip();
       $.each(window.underdogs, function( key, value ) {
           var parentPopular = $("[data-popular='" + value.playId +"']");
           var gameDiv = $("[data-betCode='" + value.betCode +"']", parentPopular )
           slip.addToSlip(value.playId, value.homeTeam, value.awayTeam, value.odd, value.betType, value.betCode, gameDiv, language);
       });
    });

    /**
     * Test is JSON string.
     * @param {string} str
     */
    const isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    // On custom logout message from parent iframe.
    window.addEventListener("message", (event) => {
        try {
          if (!isJsonString(event)) {
            if (JSON.parse(event.data).payload.action == 'customLogout') {
              window['customLoggedIn'] = true;
              window['customToken'] = '';
              $('#ticketsScroll').html('');
            } 
          }
        } catch (error) {
          console.log(error);
        }
    }, false);
});

function init() {
    getConfig();
    getDefaults();
    getStats();
    ticket.getTickets();
}

function getDefaults() {
    var tmp = null;
    $.ajax({
        url: window['API_URL'] + '/vfootball-league/game/get',
        type: "post",
           data: {  } ,
           success: function (response) {
               if(Object.keys(response['LeagueMatches']).length === 0) {
                    setTimeout(function() {
                        init();
                    }, 2000);
                 return false;
               }
               slip.emptySlip();
               createPopularOdds(response);
               createUnderdogs(response);
               tmp = response;
               gameState = response['LeagueMatches'][0].MatchStatus;
               waitTimer = response['LeagueMatches'][0].MatchTimer;
               odds.draw(response['LeagueMatches']);
               setBetScreen(gameState, waitTimer, tmp);
          },
          error: function(jqXHR, textStatus, errorThrown) {
              if(debug){
                  alert(errorThrown);
              }
          }
      });
    return tmp;
}

function getStats() {
    $.ajax({
        url: window['API_URL'] + '/vfootball-league/statistics/get',
        type: "post",
           data: {  },
           success: function (response) {
               table.drawRankingTable(response['LeagueStats'])
          },
          error: function(jqXHR, textStatus, errorThrown) {
              if(debug){
                  alert(errorThrown);
              }
          }
    });
}

function getConfig() {
    $.ajax({
        url: window['API_URL'] + '/vfootball-league/game-config/get',
        type: "post",
           data: {SessionID: token},
           success: function (response) {
               window['currency'] = response['Currency']; 
               window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] != '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;

               if(window['menu']) {
                   $("#nav-icon1").show();
                   window['renderMenu']();
               }
               window.MaxBet = response['FootBall_MaxBet'];
               window.MinBet = response['FootBall_MinBet'];
               window.MaxWin = response['League_MaxWin'];
               window['showLogin'] =  (response['showLogin'] !== undefined && response['showLogin'] != '' && response['showLogin'] != null) ? response['showLogin'] : 0;

               // Sets jackpot and mega-jackpot values.
               document.querySelector('.jackpot-amount-val').innerHTML = response['League_JackPotValue'] ? response['League_JackPotValue'].toFixed(2) : '' ;
               document.querySelector('.mega-jackpot-amount').innerHTML = response['Global_JackPotValue'] ? response['Global_JackPotValue'].toFixed(2) : '' ;

               $('#slip-btn').val(response['League_DefaultBet']).attr('min', response['League_MinBet']);
               $('#min-bet').text(response['FootBall_MinBet']).attr('data-value', response['FootBall_MinBet']);
               $('#max-bet').text(response['FootBall_MaxBet']).attr('data-value', response['FootBall_MaxBet']);
               $('#slip-btn').attr('max', response['FootBall_MaxBet']);
               $('#bet-100').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
               $('#bet-200').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
               $('#bet-400').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
               $('#betting-btn').val(parseFloat(response['FootBall_MinBet']).toFixed(2))
                  .attr('min', response['FootBall_MinBet'])
                  .attr('max', response['FootBall_MaxBet'])
                    .attr('step', response['FootBall_MinBet'])
                $('#total-stake').text(response['FootBall_MinBet']);
               showNavbar();
               // manages any click and login/logout events
               loginManagement(auth, user, navbar, credit);
                // Call chat script
                if (window['token'] && !/terminal/.test(window.location.href)) {
                  chat(window['token']);
                }
           },
           error: function(jqXHR, textStatus, errorThrown) {
               if(debug) {
                   console.log(jqXHR.responseText);
               }
           }
       });
}

function setBetScreen(gameStatus, timer, data) {
    if(gameStatus == 0){
        showOdds();
    } else if(gameStatus == 1){
        startMatch(data);
    }else {
        showResult(data);
    }
    screenCountdown(timer)
}

function screenCountdown(timer) {
    $('.vdh-progress').show();
    $('.vdh-time').show();

    let initialWidth = parseInt(timer) * 100 / 120;
    $('.vdh-progress-bar').css('width', initialWidth + '%');

    var gameTimer;
    clearInterval(gameTimer);
    gameTimer = setInterval(function(){
        --timer;
         initialWidth = initialWidth - (1 * 100 / 120);
        $('.vdh-progress-bar').css('width', initialWidth + '%');
        if(timer <= 0){
            clearInterval(gameTimer);
            init();
        }
    },1000);
}

function createPopularOdds(data){
    $.each( data['LeagueMatches'], function( key, value ) {
        var betType;
        var betCode;
        var odd;
        if(parseFloat(value.Winner1) <= parseFloat(value.Winner2) && parseFloat(value.Winner1) < parseFloat(value.WinnerX)){
            odd = value.Winner1;
            betType = '1';
            betCode = 1;
        }
        if(parseFloat(value.Winner1) >= parseFloat(value.Winner2) && parseFloat(value.Winner2) < parseFloat(value.WinnerX)){
            odd = value.Winner2;
            betType = '2';
            betCode = 2;
        }
        if(parseFloat(value.WinnerX) <= parseFloat(value.Winner2) && parseFloat(value.Winner1) > parseFloat(value.WinnerX)){
            odd = value.WinnerX;
            betType = 'X';
            betCode = 0;
        }

        window.currenPopularOdds[key] = {
           playId : value.ID,
           homeTeam : value.TeamNameHome,
           awayTeam : value.TeamNameAway,
           betType : betType,
           betCode: betCode,
           odd : odd
        }
    });
}

function createUnderdogs(data){
    $.each( data['LeagueMatches'], function( key, value ) {
        var betType;
        var betCode;
        var odd;
        if(parseFloat(value.Winner1) >= parseFloat(value.Winner2) && parseFloat(value.Winner1) > parseFloat(value.WinnerX)){
            odd = value.Winner1;
            betType = '1';
            betCode = 1;
        }
        if(parseFloat(value.Winner1) <= parseFloat(value.Winner2) && parseFloat(value.Winner2) > parseFloat(value.WinnerX)){
            odd = value.Winner2;
            betType = '2';
            betCode = 2;
        }
        if(parseFloat(value.WinnerX) >= parseFloat(value.Winner2) && parseFloat(value.Winner1) < parseFloat(value.WinnerX)){
            odd = value.WinnerX;
            betType = 'X';
            betCode = 0;
        }

        window.underdogs[key] = {
           playId : value.ID,
           homeTeam : value.TeamNameHome,
           awayTeam : value.TeamNameAway,
           betType : betType,
           betCode: betCode,
           odd : odd
        }
    });
}

function showOdds(){
    // console.log('Show new matches...');
    if(Object.keys(latestResults).length === 0){
        $('.vfl-lr-holder').css({'visibility': 'hidden'})
    } else {
        $('.vfl-lr-holder').css({'visibility': 'visible'});
        results.drawLatestResults();
    }
    getStats();
    $('.bet-choose').not(":has(span.disabled-bet)").removeClass('gt-odds-disabled');
}

function startMatch(data){
    // console.log('Start match...');
    if(Object.keys(latestResults).length === 0){
        $('.vfl-lr-holder').css({'visibility': 'hidden'})
    } else {
        $('.vfl-lr-holder').css({'visibility': 'visible'});
    }

    results.drawLatestResults();

    $('.bet-choose').addClass('gt-odds-disabled');
    results.getLatestResults(data);
    if (!IFRAME_DOMAINS.includes(window.location.hostname)) {
        video.playVideo(data);
    }

}



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/league.js
// module id = 2000
// module chunks = 4